import { useTranslation } from "react-i18next";

interface DataPillProps {
  title?: string;
  value: string;
  unit: string;
  icon: React.ReactElement;
}

export const DataPill = ({ title, value, unit, icon }: DataPillProps) => {
  const { t } = useTranslation();
  const numeric = Number(value);
  const display = Number.isFinite(numeric)
    ? (numeric / 1000).toFixed(2)
    : value;
  return (
    <div className="flex flex-col gap-4">
      {title && <p className="font-bold">{t(title)}</p>}
      <div className="shadow-card-around border border-gray-200 rounded-full w-80">
        <div className="px-4 py-1 flex items-center gap-2">
          {icon}
          <div className="flex items-center gap-2 mb-4">
            <div className="font-bold">{display}</div>
            <div>{unit}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
